import React, { useRef, useState } from "react";
import { CardDeck, Form, FormControl, Row } from "react-bootstrap";
import { useDispatch } from "react-redux";
import LocationData from "../../../../assets/static/Locations.json";
import LocationCard from "./card";
import "./styles.css";

function LocationResources() {
  const dispatch = useDispatch();
  const locationsRef = useRef(Object.values(LocationData));
  const [search, setSearch] = useState("");

  return (
    <div>
      <Form.Group className="ml-4 mr-4 mt-4" as={Row} controlId="search">
        <FormControl
          type="text"
          placeholder="Search"
          value={search}
          onChange={(e) => setSearch(e.currentTarget.value.toLowerCase())}
        />
      </Form.Group>
      <CardDeck className="m-4 justify-content-between">
        <LocationCard loc={"All Locations"} dispatch={dispatch} />
        {locationsRef.current
          .map((loc) => loc.toString())
          .filter((loc) => loc.toLowerCase().includes(search))
          .map((loc, id) => (
            <LocationCard key={id} loc={loc} dispatch={dispatch} />
          ))}
      </CardDeck>
    </div>
  );
}

export default LocationResources;
